import { render } from "./BrushSizeInput.vue?vue&type=template&id=d256660c&scoped=true"
import script from "./BrushSizeInput.vue?vue&type=script&lang=js"
export * from "./BrushSizeInput.vue?vue&type=script&lang=js"

import "./BrushSizeInput.vue?vue&type=style&index=0&id=d256660c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d256660c"]])

export default __exports__